import React, { FC, useEffect, useState } from 'react';
import { useSigma } from 'react-sigma-v2';

import { FiltersState, WYMMO_ITEM, WYMMO_TAG, WymmoDirectory } from '../types';

// function prettyPercentage(val: number): string {
//   return (val * 100).toFixed(1) + '%';
// }

const GraphTitle: FC<{ filters: FiltersState; date: number; dataset: WymmoDirectory; }> = ({ filters, date, dataset }) => {
  const sigma = useSigma();
  const graph = sigma.getGraph();

  const [visibles, setVisibleItems] = useState<{ items: number; tags: number; edges: number }>({
    items: 0,
    tags: 0,
    edges: 0,
  });

  useEffect(() => {
    // To ensure the graphology instance has up to data "hidden" values for
    // nodes, we wait for next frame before reindexing. This won't matter in the
    // UX, because of the visible nodes bar width transition.
    requestAnimationFrame(() => {
      const index = { items: 0, tags: 0, edges: 0 };
      graph.forEachNode((_, { hidden, wymmoType }) => {
        if (!hidden) {
          if (wymmoType === WYMMO_ITEM) {
            index.items++
          } else if (wymmoType === WYMMO_TAG) {
            index.tags++
          };;
        }
      });
      graph.forEachEdge(
        (_, _2, _3, _4, source, target) => !source.hidden && !target.hidden && index.edges++
      );
      setVisibleItems(index);
    });
  }, [filters, date]);

  // const items_count = dataset.items.length;
  // const tags_count = dataset.tags.length;

  return (
    <div className="graph-title">
      {/* <h1>Les professionnels de l'immobilier Français</h1> */}
      <h2>
        <i>
          {visibles.items} produit{visibles.items > 1 ? 's' : ''}{' '} / {visibles.tags} catégorie{visibles.tags > 1 ? 's' : ''}
          {/* {visibleItems.items !== items_count ? ` (sur ${items_count} au total)` : ''} */}
        </i>
      </h2>
    </div>
  );
};

export default GraphTitle;
